import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './ViewCategorySkeleton.css'

function ViewCategorySkeleton() {
    return (
        <div className={s.viewCategorySkeletonContainer}>
            <div className={s.viewCategorySkeletonLsBox}>
                <div>
                    <Skeleton className={s.viewCategorySkeletonImg} />
                    <div className={s.viewCategorySkeletonInfoContainer}>
                        <Skeleton className={s.viewCategorySkeletonTitle} />
                        <Skeleton className={s.viewCategorySkeletonDesc} />
                        <Skeleton className={cx(s.viewCategorySkeletonDesc, s.viewCategorySkeletonSmallDesc)} />
                        <Skeleton className={s.viewCategorySkeletonLink} />
                    </div>
                </div>
            </div>
            <div className={s.viewCategorySkeletonRsBox}>
                <div className={s.viewCategorySkeletonSearchContainer}>
                    <Skeleton className={s.viewCategorySkeletonSearchTitle} />
                    <Skeleton className={s.viewCategorySkeletonLabel} />
                    <Skeleton className={s.viewCategorySkeletonInput} />
                </div>
            </div>
        </div>

    )
}

export default withStyles(s)(ViewCategorySkeleton);
